import API from "serviceshift-ui/api-client";

import { hideDepartmentNavItem, showDepartmentNavItem } from "@/Navbar/navbar";
import { Department, DepartmentArchiveConfirm } from "@/typings/department";

export default {
  async archiveDepartmentConfirm(_, department: Department) {
    const response = await API.makeRequest(department.links.archive_confirm, {
      method: "GET"
    });
    return new DepartmentArchiveConfirm(response.data);
  },
  async archiveDepartment({ dispatch }, department: Department) {
    await API.makeRequest(department.links.archive, { method: "PUT" });
    hideDepartmentNavItem(department.name);
    dispatch("fetchDepartments");
  },
  async unarchiveDepartment({ dispatch }, department: Department) {
    await API.makeRequest(department.links.unarchive, { method: "PUT" });
    showDepartmentNavItem(department.name);
    dispatch("fetchDepartments");
  },
  fetchDepartments({ commit }) {
    return API.department.getAll().then((res) => {
      commit("replace", {
        state: "departments",
        data: res.data
      });
    });
  },
  fetchDepartment({ commit }, id) {
    return API.department.get(id).then((response) => {
      commit("replace", {
        state: "currentDepartment",
        data: response.data
      });
    });
  },
  clearCurrentDepartment({ commit }) {
    commit("replace", {
      state: "currentDepartment",
      data: null
    });
  },
  updateDepartment({ commit }, updatedDepartment) {
    return API.makeRequest(`/v2/departments/${updatedDepartment.id}`, {
      method: "PUT",
      data: { department: updatedDepartment }
    }).then(() => {
      commit("replace", {
        state: "currentDepartment",
        data: null
      });
    });
  },
  createDepartment(_, newDepartment) {
    return API.makeRequest(`/v2/departments`, {
      method: "POST",
      data: { department: newDepartment }
    }).then(() => {
      location.reload();
    });
  },
  fetchDepartmentPriceSheets({ commit }, params) {
    return API.department.getPriceSheets(params.id).then((res) => {
      commit("replace", {
        state: "departmentPriceSheets",
        data: res.data
      });
    });
  },
  createDepartmentPriceSheet(_, params) {
    return API.department.createPriceSheet(params.id, params.data);
  },
  updateDepartmentPriceSheet(_, params) {
    return API.department.updatePriceSheet(params.id, params.data);
  },
  deleteDepartmentPriceSheet(_, params) {
    return API.department.deletePriceSheet(params.id, params.priceSheetId);
  },
  uploadDepartmentPriceSheet(_, params) {
    const { id, priceSheetId, data } = params;
    return API.department.uploadPriceSheet(id, priceSheetId, data);
  },
  setDepartment({ commit }, data) {
    commit("replace", {
      state: "department",
      data
    });
  },
  downloadDepartmentPricebook(_, { id }) {
    return API.makeRequest(`/reports/pricebook`, {
      method: "POST",
      data: { department_id: id }
    });
  },
  uploadDepartmentPricebook(_, { id, file }) {
    const formData = new FormData();
    formData.append("file", file);
    return API.makeRequest(`/v2/departments/${id}/pricebooks`, {
      method: "POST",
      data: formData
    });
  }
};
